module.exports = __webpack_public_path__ + "static/assets/19d8ad9efd669b711c5e76a124f0c77f.png";